import {SAVE_ACTIVITY_NAME, SAVE_ACTIVITY_NAME_SUCCESS} from "./activityActionType";

export const activityReducer = (
    state = {
        fetching : false,
        error: '',
        data: {
            saveActivities: [],
        }
    },
    action
) => {
    switch (action.type) {

        case SAVE_ACTIVITY_NAME:
            return {
                ...state,
                fetching: false,
                data: {
                    ...state.data,
                    saveActivities: action.payload
                },
            };

        case SAVE_ACTIVITY_NAME_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        default:
            return state;
    }
};

